import "./style.css";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { activeUser } from "../../Store/Slices/APIs";
import Common from "../../Util/common";
import { useNavigate } from "react-router";
import { getPlaylistType, GetSelectedTrackIdByPlaylistType, isVideoUrl, SetPlaylistTrackId, showPlaylistOption } from "../../Util/helpers";
import { VideoIcon } from "../../Assets/svg";
import { setIsMixSaved, setMixSavedId } from "../../Store/Slices/SaveMixSlice";
import AddToPlaylistButton from "../BottomPlayerBar/Playlist/AddToPlaylistButton";
import { addMultipleTracks, addSingleTrack, appendTracksToPlaylist, playAllTracks, removeAllTracks, removeSingleTrack, resetConfig, setConfig } from "../../Store/Slices/PlayerSlice";

const CustomCard = ({ item, type, image }) => {

  const playlist_config = {
    id: item?.id,
    name: item?.title,
    data: [item],
    isSavedPlaylist: false,
    playlist_type: getPlaylistType(item)
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const tracks = useSelector((state) => state.player.playingTracks);
  const config = useSelector((state) => state.player.config);

  const [isSelected, setIsSelected] = useState(false);

  const isRelaxation = item?.type === Common.RELAXATION;
  const isFeaturedMix = type === Common.CATEGORIES['mix'];
  const isPlaylist = config?.type === "playlist";

  useEffect(() => {
    if (config?.type === "mix") {
      setIsSelected(config['id'] === item?.id);
    } else {
      setIsSelected(tracks.some(t => t.id === item?.id));
    }
  }, [tracks, item?.id]);

  const handleCardClick = () => {

    // when display-banner only to show the card. no functionality!
    if (type === 'display-banner') return;

    // const isRelaxation = item?.type === Common.RELAXATION;
    // const isFeaturedMix = type === Common.CATEGORIES['mix'];

    // Navigate if it's a video
    if (isVideoUrl(item?.video_url)) {
      const detailType = isRelaxation ? Common.RELAXREST : item?.type;
      navigate(`/audio-detail/${detailType}/${item?.id}`);
      return;
    }

    // Update mix state
    dispatch(setMixSavedId(null));

    // Active User
    dispatch(activeUser());

    // Add or remove tracks
    if (isSelected) {
      dispatch(isFeaturedMix ? removeAllTracks({ item }) : removeSingleTrack({ item }));
    } else {
      const data = isPlaylist ? [...tracks, ...[item]] : [];
      const type = isFeaturedMix ? 'mix' : isPlaylist ? 'playlist' : 'default';
      const obj = {
        id: item?.id,
        type: type,
        name: (isFeaturedMix || isPlaylist) ? item?.title ?? item?.name : '',
        data: data,
        playingId: isPlaylist ? config.playlist_ended ? item?.id : config.playingId : null,
        restartId: config.playlist_ended ? item?.id : null,
        isRepeat: isPlaylist ? config.isRepeat : false,
        isShuffle: isPlaylist ? config.isShuffle : false,
        isPlaylist: false,
        isPlaylistMix: config?.isPlaylistMix || false,
        shouldPlay: GetSelectedTrackIdByPlaylistType(item, config),
        playlist_ended: false
      }
      if (config.playlist_ended) {
        SetPlaylistTrackId(data?.id)
      }
      dispatch(isFeaturedMix ? addMultipleTracks({ item }) : isPlaylist ? appendTracksToPlaylist([item]) : addSingleTrack({ item }));
      dispatch(setConfig(obj));
      dispatch(playAllTracks());
    }
  };

  return (
    <div className="position-relative my-2">
      <div className={`customCard ${(isSelected) ? 'grendientBox' : ''}`} onClick={handleCardClick}>
        <img src={image} alt={item?.title} className="customCardImage" />
        <div className="customCardOverlay"></div>
        <h3 className="customCardTitle">{item?.title}</h3>
        {isVideoUrl(item?.video_url) && (
          <i className="customCardIcon">
            <img src={VideoIcon} className="w-100" />
          </i>
        )}
      </div>
      {showPlaylistOption(item) && (
        <div className="position-relative">
          <div className="three-dots-icon">
            <AddToPlaylistButton config={playlist_config} />
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomCard;
